// Import Swiper and modules
import Swiper from "swiper/bundle";

export const articleMetaobjects = () => {
  const $articleMetaobjects = document.querySelector(".article-metaobjects");
  if ($articleMetaobjects) {
    const $articleMetaobjectsIndex = $articleMetaobjects.querySelector(
      ".article-megaobjects__index"
    );
    if ($articleMetaobjectsIndex) {
      const $indexlist = $articleMetaobjectsIndex.querySelector(".index__list");
      const $indexExpandButton = $articleMetaobjectsIndex.querySelector(
        ".index__expand-button"
      );
      $indexExpandButton.addEventListener("click", (event) => {
        event.preventDefault();
        if ($indexlist.classList.contains("index__list--active")) {
          $indexlist.classList.remove("index__list--active");
          $indexExpandButton.innerText = "Expand";
        } else {
          $indexlist.classList.add("index__list--active");
          $indexExpandButton.innerText = "Reduce";
        }
      });
    }

    const $articleMetaobjectsContent = $articleMetaobjects.querySelector(
      ".article-metaobjects__content"
    );

    const $metaobjectProductsSections =
      $articleMetaobjectsContent.querySelectorAll(".metaobject__products");
    $metaobjectProductsSections.forEach(($metaobjectProductsSection) => {
      const $swiper = $metaobjectProductsSection.querySelector(
        ".featured-products__products.swiper"
      );
      if ($swiper) {
        const swiperConfig = {
          slidesPerView: 1.2,
          loop: false,
          spaceBetween: 10,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 16,
            },
          },
        };

        const swiperObject = new Swiper($swiper, swiperConfig);
      }
    });
  }
};

export default articleMetaobjects;
